// Footer navigation items with paths
const footerLinks = [
  {
    title: 'Products',
    links: [
      { text: 'Platform Overview', href: '/platform-overview' },
      { text: 'Spatial AI', href: '/spatial-ai' },
      { text: 'Real-Time Analytics', href: '/real-time-analytics' },
      { text: 'Multiplayer', href: '/multiplayer' },
      { text: 'Operating System', href: '/operating-system' },
    ],
  },

  {
    title: 'Resources',
    links: [
      { text: 'Documentation & Support', href: '/documentation' },
      { text: 'Help Center', href: '/help-center' },
      { text: 'Spatial Grid Blogs', href: '/resource/blogs' },
      { text: 'University Alliance', href: '/university-alliance' },
      { text: 'Spatial Grid Research', href: '/spatialgrid-research' },
    ],
  },
  {
    title: 'Industries',
    links: [
      {
        text: 'Manufacturing & Industrial',
        href: '/industries/manufacturing-industrial',
      },
      {
        text: 'Education & Training',
        href: '/industries/education-training',
      },
      { text: 'Defence & Aerospace', href: '/defence-aerospace' },
      {
        text: 'Healthcare and Pharma',
        href: '/industries/healthcare-pharma',
      },
      {
        text: 'Automotive & Transportation',
        href: '/industries/automotive-transportation',
      },
      { text: 'Energy and Mining', href: '/industries/energy-mining' },
      { text: 'Retail & E-Commerce', href: '/industries/retail-ecommerce' },
      {
        text: 'Architecture & Real Estate',
        href: '/industries/realstate-architecture',
      },
      {
        text: 'Tourism & Hospitality',
        href: '/industries/tourism-hospitality',
      },
    ],
    expandable: true,
  },
  {
    title: 'Company',
    links: [
      { text: 'About Us', href: '/about-us' },
      { text: 'Careers', href: '/careers' },
      { text: 'Terms & Conditions', href: '/terms-conditions' },
      { text: 'Privacy Policy', href: '/privacy-policy' },
      { text: 'Security', href: '/security-and-trust' },
    ],
  },
  {
    title: 'Contact',
    links: [
      {
        text: 'software@spatialgrid.ai',
        href: 'mailto:software@spatialgrid.ai',
      },
      { text: '+918978078143', href: 'tel:+918978078143' },
    ],
  },
];
export default footerLinks;